module.exports = __webpack_public_path__ + "media/images/anden-51da9dd6.webp";